var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.facet.type,{tag:"component",attrs:{"facet":_vm.facet,"criteria":_vm.boundCriteria,"data-facet-name":_vm.facet.name},on:{"update:criteria":function($event){_vm.boundCriteria=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }